export class ListWorkspacesFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "WorkspaceStatusFilters",
            "format": ""
        },
        {
            "name": "includeDisabled",
            "baseName": "includeDisabled",
            "type": "BooleanFilters",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "cloud",
            "baseName": "cloud",
            "type": "StringFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListWorkspacesFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
